/* eslint-disable default-case */
/* eslint-disable no-console */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

// eslint-disable-next-line import/no-extraneous-dependencies
// import { LogLevel } from "@azure/msal-browser";
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

const msalBaseConfig = {
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {},
}

export const createMsalConfig = ({
    clientId,
    authority,
    redirectUri,
    postLogoutRedirectUri = '/',
    navigateToLoginRequestUrl = false,
}) => ({
    auth: {
        clientId, // This is the ONLY mandatory field that you need to supply.
        authority, // Defaults to "https://login.microsoftonline.com/common"
        redirectUri, // Points to the URI registered on Azure Portal/App Registration.
        postLogoutRedirectUri, // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: msalBaseConfig.cache,
    system: msalBaseConfig.system,
})
/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ['User.Read'],
}

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
    scopes: ['openid', 'profile'],
    loginHint: 'example@domain.net',
}

// Add Okta config object
export const oktaConfig = {
    issuer: 'https://amaurygroupe.okta.com',
    clientId: '0oar1ohjjw046t8sq697',
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ['openid', 'profile', 'email'],
}
